export default __webpack_public_path__ + "static/media/template_pro__0000_27---TimothyAdams.ed46f663.png";